export default __webpack_public_path__ + "static/29_Map_04@2x-90f6233c4dfcbb5a788632eb20f7988e.png";